var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnowflake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4L12 5L14 4M12 2V8.5L15 10.22M17.928 6.268L18.062 8.5L19.928 9.732M20.66 7L15.031 10.25L15.041 13.708M19.928 14.268L18.062 15.5L17.928 17.732M20.66 17L15.031 13.75L12.041 15.488M14 20L12 19L10 20M12 22V15.5L9 13.78M6.072 17.732L5.938 15.5L4.072 14.268M3.34 17L8.969 13.75L8.959 10.292M4.072 9.732L5.938 8.5L6.072 6.268M3.34 7L8.969 10.25L11.959 8.512",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/Snowflake.13ed99e846499d20473b178d74fd796f.svg";
export { ForwardRef as ReactComponent };